import get from 'lodash/get';
import * as types from './constants';
const defaultState = {
  loading: false,
  error: null,
  activeStep: 0,
  application: {},
  breakdown: {},
  documents: [],
  property: {},
  buyers: [],
  sellers: [],
  applicationId: null,
  paymentPlanType: '',
  applicationType: '',
  brokers: [],
  instalmentPlanList: [],
  contractDetails: {},
  updatePercentbuyer: [],
  representativeDetails: [],
};

export default function offPlanReducerPost(state = defaultState, action = {}) {
  switch (action.type) {
    case types.FETCH_APPLICATION_OFFPLAN:
      return {
        ...state,
        loading: true,
        application: null,
      };
    case types.FETCH_APPLICATION_OFFPLAN_SUCCESS:
      return {
        ...state,
        loading: false,
        application: get(action.payload, 'application', {}),
        applicationId: get(action.payload, 'applicationId', {}),
        buyers: get(action.payload, 'buyers', []),
        brokers: get(action.payload, 'brokers', []),
        representativeDetails: get(action.payload, 'representativeDetails', []),
        instalmentPlanList: get(action.payload, 'instalmentPlanList', []),
        paymentPlanType: get(action.payload, 'paymentPlanType', []),
        documents: get(action.payload, 'documents', []),
        property: get(action.payload, 'property', {}),
        breakdown: get(action.payload, 'breakdown', {}),
        contractDetails: get(action.payload, 'contractDetails', {}),
      };
    case types.FETCH_APPLICATION_OFFPLAN_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.DOWNLOAD_DOCUMENT_OFFPLAN:
      return {
        ...state,
        loading: true,
      };
    case types.DOWNLOAD_DOCUMENT_OFFPLAN_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case types.DOWNLOAD_DOCUMENT_OFFPLAN_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.OFFPLAN_CANCEL_APPLICATION:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.OFFPLAN_CANCEL_APPLICATION_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null,
      };
    }
    case types.OFFPLAN_CANCEL_APPLICATION_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.DOWNLOAD_OFFPLANE_CONTRACT_DOCUMENT:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.DOWNLOAD_OFFPLANE_CONTRACT_DOCUMENT_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null,
      };
    }
    case types.DOWNLOAD_OFFPLANE_CONTRACT_DOCUMENT_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
}
